import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { userService } from '../../application/UserService';
import { useShowSnackbarMessage } from '../snackbarMessage/useShowSnackbarMessage';

interface UseValidateUser {
  token: string;
}

type UseValidateUserResponse = ServiceResponse<null, void>;

// Hooks act as 'Adapter' layer.
const useValidateUser = ({ token }: UseValidateUser): UseValidateUserResponse => {
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const { isLoading } = useQuery([`planner_validate_user`], () => userService.validate({ token }), {
    retry: false,
    refetchOnWindowFocus: false,
    onError: (err: any) => {
      console.info(`User Validate Error: `, err?.response);

      let messageIntlId = `infoerror.unexpectedresult`;

      if (err?.response?.data?.messageId !== ``) {
        if (err?.response?.data?.messageId === `highway.user.error.invalid_token`) {
          messageIntlId = `infoerror.highway.user.error.invalid_validation_token`;
        } else {
          messageIntlId = `infoerror.${err.response.data.messageId}`;
        }
      } else if (err?.response?.status === 401) {
        messageIntlId = `infoerror.highway.user.error.invalid`;
      }

      showSnackbarMessage({
        messageIntlId,
        autoHideDuration: err.response && err.response.status === 401 ? undefined : 5000,
      });
    },
  });

  return {
    success: false,
    error: false,
    isLoading,
    run: null,
  };
};

export default useValidateUser;
